import React from 'react'
import { get } from 'lodash'
import VideoJSPlayer from '~/components/VideoPlayer'
import { getVideoData } from '~/redux/uservideo/helpers'
import './styles.css'
import connect from "connect";
import userStore from "~/redux/user/store"

class EmbedPlayer extends React.Component {
  componentDidMount() {
    const url = new URLSearchParams(window.location.search)
    const videoId = url.get('filmId')
    getVideoData(videoId, response => {
      const video = response
			this.setState({
				videoId: videoId,
				video: video,
				noAds: url.get('noAd'),
				autoplay: (url.get('autoplay') === "false") ? false : true
			})
    })
  }

  render() {
    const videoId = this.state.videoId

    return (
     <div className="embed-player">
        { videoId && <VideoJSPlayer
          {...this.state}
          videoId={videoId}
          fileType={this.props.layout.settings.fileType}
          isFree={true}
          pricingOptions={{'type': null}}
          isTrailer={false}
          autoplay={this.state.autoplay}
          videoTag={!this.state.noAds && get(window.settings, 'advertising.videoTag')}
        /> }
      </div>
    )
  }
}

connect(EmbedPlayer, state => ({ user: state.user }), userStore)

export default EmbedPlayer
